module.exports = __webpack_public_path__ + "img/sit.bb0873d0.svg";